module.exports = __webpack_public_path__ + "static/media/kids_04.31242692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_04.jpg
// module id = 5860
// module chunks = 0